
/**
 * Get the business status based on is_active and is_listed flags
 * @param isActive Whether the business is active
 * @param isListed Whether the business is listed
 * @returns An object containing status information
 */
export const getBusinessStatus = (isActive: boolean, isListed: boolean) => {
  if (isListed) {
    return {
      key: 'listed',
      label: 'Listed',
      className: 'bg-green-100 text-green-800 border-green-200',
    };
  } 
  
  if (isActive) {
    return {
      key: 'pending-subscription',
      label: 'Pending Subscription',
      className: 'bg-amber-100 text-amber-800 border-amber-200',
    };
  }
  
  return {
    key: 'pending-validation',
    label: 'Pending Validation',
    className: 'bg-red-100 text-red-800 border-red-200',
  };
};
